import apiClient from "../../apiClient";

export default {
    state: {
        rooms: []
    }, actions: {
        async updateRoom({dispatch}, {id, payload}) {
            return apiClient.put(`/rooms/${id}`, payload).then(response => response.data)
        },
        updateRoomTheme({dispatch}, {id, theme}) {
            return dispatch(`updateRoom`, {
                id,
                payload: {
                    theme
                }
            }).then(response => response.theme)
        },
        async getRooms({state}) {
            state.rooms = await apiClient.get("/rooms")
                .then(response => response.data)
        },
        async createRoom({dispatch}, {nickname, isPublic, copyFrom}) {
            await apiClient.post("/rooms", {nickname, isPublic, ...(copyFrom && {copyFrom})})
            dispatch("getRooms")
        },
        async renameRoom({dispatch}, {nickname, id}) {
            await dispatch(`updateRoom`, {
                id,
                payload: {nickname}
            })
            dispatch("getRooms")
        },
        async deleteRoom({dispatch}, id) {
            await apiClient.delete(`/rooms/${id}`)
            dispatch("getRooms")
        }
    }
}